import styled from 'styled-components';

export const FutureVisionSection = styled.section`
  padding: 5rem 0;
  background: linear-gradient(rgba(0, 0, 128, 0.8), rgba(30, 144, 255, 0.8)), url('/back_imgs/services.png') no-repeat center center;
  background-size: cover;
  color: var(--light-text);

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const TextContent = styled.div`
  @media (max-width: 992px) {
    order: 1;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const SectionDescription = styled.div`
  font-size: 1.1rem;
  line-height: 1.7;

  p {
    margin-bottom: 1.5rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const ImageContent = styled.div`
  .image-placeholder {
    width: 100%;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    &:after {
      content: 'Imagem Representativa';
      position: absolute;
      color: rgba(255, 255, 255, 0.7);
      font-size: 1.2rem;
    }
  }

  @media (max-width: 992px) {
    order: 2;
    
    .image-placeholder {
      height: 300px;
    }
  }
`;